import '../styles/Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
        <a href="/#accueil"><span className="logo-text">Ummah <span className="logo-elite">Élite</span> Academy</span> </a>
        </div>
        <ul className="navbar-links">
          <li><a href="/#apropos">À propos</a></li>
          <li><a href="/#formations">Formations</a></li>
          <li><a href="/#contact">À venir</a></li>
        </ul>
        <a href="/#formations" className="btn btn-primary">Commencer</a>
      </div>
    </nav>
  );
}

export default Navbar;
